const partnerNames = ['娱乐资讯', '热点追踪', '八卦分享', '影视评论', '综艺聚合', '音乐动态'];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <span className="text-lg md:text-xl font-heading font-black text-background-50 mb-4 block">
              51吃瓜
            </span>
            <p className="text-xs md:text-sm text-background-300 leading-relaxed">
              你的随身吃瓜神器。提供51吃瓜app、51吃瓜轻量版及51吃瓜网app最新版本安装包，支持安卓下载与苹果版客户端。
            </p>
          </div>

          <div>
            <p className="text-sm font-bold text-background-50 mb-4">快速导航</p>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">首页</a>
              <a href="#about" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</a>
              <a href="#index" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">吃瓜合集</a>
              <a href="#topics" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">热门话题</a>
              <a href="#app" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">APP下载</a>
              <a href="#faq" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <p className="text-sm font-bold text-background-50 mb-4">客户端下载</p>
            <div className="flex flex-col gap-2">
              <a href="#app" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">51吃瓜app 安卓版</a>
              <a href="#app" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">51吃瓜轻量版</a>
              <a href="#app" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">51吃瓜网app 苹果版</a>
              <a href="#app" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">最新版本 v3.2.1</a>
            </div>
          </div>

          <div>
            <p className="text-sm font-bold text-background-50 mb-4">合作伙伴</p>
            <div className="flex flex-wrap gap-2">
              {partnerNames.map((name, idx) => (
                <span
                  key={idx}
                  className="text-xs text-background-400 bg-background-800 px-2.5 py-1 rounded whitespace-nowrap"
                >
                  {name}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400 text-center sm:text-left">
            © 2026 51吃瓜网址 All Rights Reserved. 本站内容仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#hero" className="text-xs text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#contact" className="text-xs text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}